// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","453":"ee671459","455":"ae2d636a","977":"58790150"}[chunkId] + ".chunk.js";
};